import React from 'react';
import Dialog, { IDialogProps } from '@/ui/dialog';
import {
  RightArrow,
  GiftThree,
  SettingTwo,
  StarTwo,
  CoinLine,
  List,
} from '@/ui/svg';
import RippleCard from '@/ui/card/RippleCard';
import { useRouter } from 'next/router';
import { sendGAEvent } from '@next/third-parties/google';

export default function MoreDialog(props: IDialogProps) {
  const router = useRouter();
  return (
    <Dialog {...props}>
      <div className="mb-4 px-4">
        <div className="flex flex-col justify-between flex-grow">
          <RippleCard
            className="flex justify-between items-center p-4 cursor-pointer"
            onClick={() => {
              router.push('/assets?tab=transaction');
            }}
          >
            <div className="flex gap-3">
              <div className="flex justify-center w-7">
                <List />
              </div>
              <div>Transactions</div>
            </div>
            <RightArrow />
          </RippleCard>
          <RippleCard
            className="flex justify-between items-center p-4 cursor-pointer"
            onClick={() => {
              router.push('/stake');
            }}
          >
            <div className="flex gap-3">
              <div className="flex justify-center w-7">
                <CoinLine className="w-6 h-6" />
              </div>
              <div>Staking</div>
            </div>
            <RightArrow />
          </RippleCard>
          <RippleCard
            className="flex justify-between items-center p-4 cursor-pointer"
            onClick={() => {
              router.push('/profile/points');
            }}
          >
            <div className="flex gap-3">
              <div className="flex justify-center w-7">
                <StarTwo />
              </div>
              <div>BitPoints</div>
            </div>
            <RightArrow />
          </RippleCard>
          <RippleCard
            className="flex justify-between items-center p-4 cursor-pointer"
            onClick={() => {
              router.push('/profile/referral');
              sendGAEvent('event', 'referal');
            }}
          >
            <div className="flex gap-3">
              <div className="flex justify-center w-7">
                <GiftThree />
              </div>
              <div>Referral</div>
            </div>
            <RightArrow />
          </RippleCard>
          <RippleCard
            className="flex justify-between items-center p-4 cursor-pointer"
            onClick={() => {
              router.push('/profile');
            }}
          >
            <div className="flex gap-3">
              <div className="flex justify-center w-7">
                <SettingTwo />
              </div>
              <div>Settings</div>
            </div>
            <RightArrow />
          </RippleCard>
        </div>
      </div>
    </Dialog>
  );
}
